// SnapTrade redirects to this route after a successful broker connection.
// We notify the opener window via postMessage and try to auto-close.
import React, { useEffect } from "react";

export default function BrokerCallback() {
  useEffect(() => {
    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: "snaptrade-connection-complete", at: Date.now() },
          window.location.origin
        );
      }
    } catch (err) {
      // Cross-origin postMessage to a different-origin opener is expected to
      // fail. Swallow only this specific case — anything else is logged.
      void err;
    }
    // Try closing the tab. Browsers only allow this if WE opened it (popup).
    // If close is blocked (custom-domain, focused tab), the message below stays visible.
    const timer = setTimeout(() => {
      try { window.close(); } catch (_) { void 0; }
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-graphite text-champagne flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <div className="text-[10px] tracking-[0.35em] uppercase text-paars/80 mb-4">// CONNECTION_COMPLETE</div>
        <h1 className="text-3xl font-bold mb-3">Broker linked</h1>
        <p className="text-stone/80 leading-relaxed mb-6">
          Returning you to BabyBonds Tracker… If this tab doesn&rsquo;t close automatically, you can close it and we&rsquo;ll sync your positions in the main window.
        </p>
        <button
          onClick={() => { try { window.close(); } catch (_) { window.location.href = "/holdings"; } }}
          className="px-5 py-2.5 bg-paars text-graphite text-xs tracking-wider uppercase font-semibold hover:bg-paars-light"
          data-testid="broker-callback-close-btn"
        >
          Close tab
        </button>
      </div>
    </div>
  );
}
